

































































import { Component, Model, Vue } from 'vue-property-decorator';
import { ListItem, ListItemPart, Overlay, Pagination } from '../components';
import {Org, Dict, Comp, Utils} from '../types';
import { debugUtilKeys, debugUtilObject, store } from "../common";
import I18n from "@/modules/budget/staffing-table/I18n";
import BudgetFormsList from "@/modules/budget-request/components/budget-forms-list.vue";
import {Ax} from "@/utils";
import auth from "@/services/auth";
import i18nLocal from "@/services/i18n";
const noValue = Symbol('modules/budget/staffing-table/components/SingleKgkpSelection.vue :: No value');
const modelChangeEvent = 'change';
const i18n = new I18n('modules.budget.staffing_table.components.SingleKgkpSelection');

const translates = {
    buttons: {
        get expiredKgkpTitle(): string {
            return i18nLocal.choose('Закрытые КГКП', 'Закрытые КГКП (каз)', 'Closed KGKP');
        }
    },
    titles: {
        get searchTitle(): string {
            return i18nLocal.choose('Поиск', 'Іздеу', 'Search:');
        },
        get noResultTitle(): string {
            return i18nLocal.choose('Ничего не найдено', 'Ничего не найдено (каз)', 'No Results:');
        }
    }
}

@Component({
    components: {
        BudgetFormsList,
        'list-item': ListItem,
        'list-item-part': ListItemPart,
        'overlay': Overlay,
        'pagination': Pagination,
    },
})
export default class SingleKgkpSelection extends Vue {

    public translate = translates

    // region Model, properties
    @Model(
        modelChangeEvent,
        {
            type: Object,
            required: false,
            default: noValue,
        },
    )
    public value!: Org.Kgkp | null | symbol;


   private created () {
       // region Model, properties
       this.$watch('value', (value: Org.Kgkp | null | symbol) => {
           if (typeof value === 'symbol') return;
         if (this.localValue?.kgkp.id ! == value?.kgkp.id){
             this.localValue = value;
         }
       })
       // endregion

       // region КГКП list
       this.$watch('selectedAbp', (selectedAbp: Dict.EbkFunc | null) => {
           if (selectedAbp !== null) {
               this.searchText = ''
               store.abp = selectedAbp;
               this.reloadKgkpList()
           }
       });
       // endregion

       // region Kgkp list
       this.$watch('itemsPerPage', () => {
           if (this.page === 0) {
               this.reloadKgkpList();
           } else {
               this.page = 0;
           }
       });
       this.$watch('page', () => {
           this.reloadKgkpList();
       });

       this.$watch('localValue', (localValue: Org.Kgkp | null) => {
           if ((typeof this.value === 'symbol') || (this.value?.kgkp.id !== localValue?.kgkp.id)) {
               this.$emit(modelChangeEvent, localValue);
           }
       });

       this.$watch('showExpiredKgkp', () => {
               this.page = 0
               this.reloadKgkpList();
           }
       )

       this.$watch('enableAccessKgkp', () => {
           this.page = 0
           this.reloadKgkpList();
       });
       // endregion
   }
    // endregion

    private mounted() {
        if (typeof this.value !== 'symbol') {
            this.localValue = this.value;
        }
        this.reloadAbpList();
    }

    // region Utils
    private i18n = i18n;

    private get isKazakh(): boolean {
        return this.i18n.isKazakh;
    }

    private toast(type: 'danger' | 'warning' | 'success', title: string, message: string) {
        this.$bvToast.toast(message, {
            title: title,
            variant: type,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
    // endregion

    // region Misc data
    private get userId(): string {
        return auth.user.sub;
    }

    private localValue: Org.Kgkp | null = null;

   private get loading () {
       return (this.abpLoading || this.kgkpLoading)
   }

    private abpLoading = false;

    // region ABP list
    private abpList: Array<Dict.EbkFunc> = [];

    private page = 0;

    private totalKgkpCount = 0;

    // Загрузка Кгкп с просроченным сроком дейсвия
    private showExpiredKgkp= false

    private searchText = '';
    private debounceTimer: any = null;

    private onInputSearchText(value: string) {
        if (value !== this.searchText) {
            clearTimeout(this.debounceTimer);

            this.debounceTimer = setTimeout(() => {
                this.searchText = value;
                this.page = 0;
                this.reloadKgkpList();
            }, 600);
        }
    }

    private get enableAccessKgkp(): boolean {
        return debugUtilObject.get<boolean>(debugUtilKeys.organization.kgkp.accessToAllKgkp) ?? false;
    }

    private itemsPerPage = 25;

    private itemsPerPageChange(value: number) { this.itemsPerPage = value; }

    private getKgkpItemVariate(kgkp: Org.Kgkp): Comp.ColorVariant | null {
        return (kgkp.kgkp.id === this.localValue?.kgkp.id) ? 'primary' : null;
    }

    private onKgkpClick(kgkp: Org.Kgkp) {
        if (kgkp.kgkp.id !== this.localValue?.kgkp.id) {
            this.localValue = kgkp;
        }
    }

    private getKgkpDetails (kgkp: Org.Kgkp): { bin: string, id: string, name: string  } {
      const id = kgkp.kgkp.id.toString()
      const bin = kgkp.code
      const name = this.i18n.isKazakh ? kgkp.nameKk : kgkp.nameRu;

      return { id, bin, name }
    }

    // Обёртка selectedAbp для v-model компонента multiselect (работает с { text, value })
    private get selectedAbpOption(): Comp.DropdownItemDef<Dict.EbkFunc> | null {
        const selectedAbp = this.selectedAbp;
        if (selectedAbp === null) return null;
        return this.abpOptions.find(option => option.value === selectedAbp) ?? null;
    }

    private set selectedAbpOption(option: Comp.DropdownItemDef<Dict.EbkFunc> | null) {
        this.selectedAbp = option?.value ?? null;
    }

    private get abpOptions(): Array<Comp.DropdownItemDef<Dict.EbkFunc>> {
        const isKazakh = this.isKazakh;

        return this.abpList.map(abp => {
            let text: string;
            if (isKazakh) {
                text = abp.nameKk || abp.nameRu || (abp.id + '');
            } else {
                text = abp.nameRu || abp.nameKk || (abp.id + '');
            }

            let code = (abp.abp?.toString() || '');
            while (code.length < 3) {
                code = '0' + code;
            }

            return {
                value: abp,
                text: `${code} - ${text}`,
            };
        });
    }

    private selectedAbp: Dict.EbkFunc | null = null

    private reloadAbpList() {
        if (this.abpLoading) {
            console.error('Cannot load ABP list - another loading is running');
            return;
        }

        const userId = this.userId;
        this.abpLoading = true;

        Ax<Array<Dict.EbkFunc>>(
            {
                url: `/api/budget/staffing_table/abp/kgkp/list-for-user/${userId}`,
            },
            data => {
                this.abpList = data;

                const savedAbp = store.abp;
                if (savedAbp === null) {
                    this.selectedAbp = null;
                } else {
                    const selectedAbp = data.find((loadedAbp) => {
                        return (
                            (loadedAbp.gr === savedAbp.gr)
                            &&
                            (loadedAbp.pgr === savedAbp.pgr)
                            &&
                            (loadedAbp.abp === savedAbp.abp)
                        );
                    });

                    this.selectedAbp = (selectedAbp ?? null);
                }
            },
            error => {
                this.toast('danger', this.i18n.translate('cannot_load_abp'), error.toString());
            },
            () => {
                this.abpLoading = false;
            },
        );
    }
    // endregion

    // noinspection JSMismatchedCollectionQueryUpdate
    private kgkpList: Array<Org.Kgkp> = [];

    private kgkpLoading = false;

    private reloadKgkpList() {
        if (this.kgkpLoading) {
            console.error('Cannot load KGKP list - another loading is running');
            return;
        }

        const selectedAbp = this.selectedAbp;
        if (selectedAbp === null) {
            console.error('Cannot load KGKP list - no selected ABP');
            return;
        }

        this.kgkpLoading = true;
        let api = `/api/budget/staffing_table/kgkp/list?items-per-page=${this.itemsPerPage}&page=${this.page}&text=${this.searchText}&user-id=${this.userId}&abp-code=${selectedAbp.abp}&expired-kgkp=${this.showExpiredKgkp}`

        if (this.enableAccessKgkp) {
            api += '&enable-debug-kgkp=true';
        }

        Ax<Utils.PaginationList<Org.Kgkp>>(
            { url: api },
            data => {
                if (this.page !== data.page) {
                    setTimeout(() => {
                        this.page = data.page;
                    });
                    return;
                }


                this.totalKgkpCount = data.itemCount;
                this.kgkpList = data.items;
            },
            error => {
                this.toast('danger', this.i18n.translate('cannot_load_kgkp'), error.toString());
            },
            () => {
                this.kgkpLoading = false;
            },
        );
    }
}
